// extracted by mini-css-extract-plugin
export default {"switch":"CheckboxInput_switch__lvDZN","checked":"CheckboxInput_checked__EIVt1","unChecked":"CheckboxInput_unChecked__I5-+U"};